import React from 'react';
import './HeroSection.css';
// import logo from '../images/logo.jpg';

function HeroSection() {
  const androidLink = "https://play.google.com/store/apps/details?id=com.roomease.roomate&hl=en_IN";
  const iosLink = "https://apps.apple.com/my/app/roomease-roommate-finder/id6743614619";
  
  const handleDownloadClick = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let os = "unknown";

    if (/android/i.test(userAgent)) {
      os = "Android";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      os = "iOS";
    }

    // --- Facebook Pixel Tracking for Download App Click (Hero Section) ---
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: 'Hero Section Download App Button Click',
        source_os: os,
      });
      console.log(`Facebook Pixel: Lead event fired for Hero Section Download App Button (${os}).`);
    } else {
      console.warn('Facebook Pixel: fbq not found, Hero Section Download App event not tracked.');
    }
    // --- End Facebook Pixel Tracking ---

    if (os === "Android") {
      window.location.href = androidLink;
    } else if (os === "iOS") {
      window.location.href = iosLink;
    } else {
      window.location.href = "https://linktr.ee/roomeaseindia";
    }
  };

  return (
    <div className="hero-container">
      <div className="hero-background-fixed"></div>
      {/* <header className="hero-header">
        <div className="header-branding">
          <img src={logo} alt="RoomEase Logo" className="header-logo" />
          <span className="header-name">RoomEase</span>
        </div>
        <button className="join-waitlist-header-button" onClick={handleDownloadClick}>
          Download App
        </button>
      </header> */}
      <div className="hero-content">
        <div className="hero-text-centered">
          <h2 className="hero-headline-centered">Find Your Perfect Roommate</h2>
          <p className="hero-subheadline-centered">Swipe to Connect with your compatible roomie.</p>
          <button className="join-waitlist-button-centered" onClick={handleDownloadClick}>
            Download App
          </button>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;